"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSubscriptionTrialing = exports.isSubscriptionPastDue = exports.isSubscriptionIncomplete = exports.isSubscriptionCanceled = exports.isSubscriptionActive = exports.getStatus = exports.getPlan = exports.getInternalUser = exports.getId = exports.getCurrentPeriodEnd = exports.getCancelAtPeriodEnd = exports.getCancelAt = void 0;
var _objects = require("../../utils/objects");
const getId = subscription => (0, _objects.getObjectProperty)(subscription, 'id');
exports.getId = getId;
const getPlan = subscription => (0, _objects.getObjectProperty)(subscription, 'plan');
exports.getPlan = getPlan;
const getStatus = subscription => (0, _objects.getObjectProperty)(subscription, 'status');
exports.getStatus = getStatus;
const getCancelAt = subscription => (0, _objects.getObjectProperty)(subscription, 'cancel_at');
exports.getCancelAt = getCancelAt;
const getCurrentPeriodEnd = subscription => (0, _objects.getObjectProperty)(subscription, 'current_period_end');
exports.getCurrentPeriodEnd = getCurrentPeriodEnd;
const getCancelAtPeriodEnd = subscription => (0, _objects.getObjectProperty)(subscription, 'cancel_at_period_end');
exports.getCancelAtPeriodEnd = getCancelAtPeriodEnd;
const getInternalUser = subscription => (0, _objects.getObjectProperty)(subscription, 'internalUser');
exports.getInternalUser = getInternalUser;
const isSubscriptionActive = subscription => (getStatus(subscription) || '').toLocaleLowerCase() === 'active';
exports.isSubscriptionActive = isSubscriptionActive;
const isSubscriptionPastDue = subscription => (getStatus(subscription) || '').toLocaleLowerCase() === 'past_due';
exports.isSubscriptionPastDue = isSubscriptionPastDue;
const isSubscriptionTrialing = subscription => (getStatus(subscription) || '').toLocaleLowerCase() === 'trialing';
exports.isSubscriptionTrialing = isSubscriptionTrialing;
const isSubscriptionIncomplete = subscription => (getStatus(subscription) || '').toLocaleLowerCase() === 'incomplete';
exports.isSubscriptionIncomplete = isSubscriptionIncomplete;
const isSubscriptionCanceled = subscription => getCancelAt(subscription) !== null;
exports.isSubscriptionCanceled = isSubscriptionCanceled;